$(function() {
	$('.startpage-slider-items').slick({

		autoplay: true,
		autoplaySpeed: 5000,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,

	});
});